import styled from 'styled-components';
import { X } from 'lucide-react';

export default function UpdateBanner({ onRefresh, onDismiss }) {
  return (
    <Banner>
      <Content>
        <Emoji>🎉</Emoji>
        <Message>
          <Title>New features available!</Title>
          <Subtitle>Refresh to get the latest updates</Subtitle>
        </Message>
      </Content>
      <Actions>
        <RefreshButton onClick={onRefresh}>Refresh Now</RefreshButton>
        <DismissButton onClick={onDismiss} aria-label="Dismiss">
          <X size={18} />
        </DismissButton>
      </Actions>
    </Banner>
  );
}

const Banner = styled.div`
  position: fixed;
  top: calc(16px + env(safe-area-inset-top, 0px));
  left: 50%;
  transform: translateX(-50%);
  z-index: 10000;
  
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  
  max-width: 500px;
  width: calc(100% - 32px);
  padding: 16px 20px;
  
  background: ${({ theme }) => theme.colors.surface};
  border: 2px solid ${({ theme }) => theme.colors.accent};
  border-radius: ${({ theme }) => theme.radius.large};
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  
  animation: slideDown 0.3s ease-out;
  
  @keyframes slideDown {
    from {
      opacity: 0;
      transform: translate(-50%, -20px);
    }
    to {
      opacity: 1;
      transform: translate(-50%, 0);
    }
  }
`;

const Content = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
  min-width: 0;
`;

const Emoji = styled.div`
  font-size: 24px;
  flex-shrink: 0;
`;

const Message = styled.div`
  flex: 1;
  min-width: 0;
`;

const Title = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.textPrimary};
  margin-bottom: 2px;
`;

const Subtitle = styled.div`
  font-size: 15px;
  color: ${({ theme }) => theme.colors.textSecondary};
`;

const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
`;

const RefreshButton = styled.button`
  padding: 8px 16px;
  border-radius: ${({ theme }) => theme.radius.medium};
  background: ${({ theme }) => theme.colors.accent};
  color: white;
  font-size: 16px;
  font-weight: 600;
  white-space: nowrap;
  transition: all 0.2s;
  
  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(245, 158, 11, 0.3);
  }
  
  &:active {
    transform: translateY(0);
  }
`;

const DismissButton = styled.button`
  padding: 6px;
  border-radius: 50%;
  background: transparent;
  color: ${({ theme }) => theme.colors.textSecondary};
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  
  &:hover {
    background: ${({ theme }) => theme.colors.surfaceSecondary};
    color: ${({ theme }) => theme.colors.textPrimary};
  }
`;
